import HeroSection from "./Components/HeroSection";
import dummyData from "./Variable/dummyData";
import Row from "./Components/Row";
import useListApi from "../../../../hooks/useListApi";
import URLS from "../../../../API/Axios/URLS";
import AnswerTemplateRow from "./Components/AnswerTemplateRow";
import {getUri} from "../../../../utils/utils";
import {FaLongArrowAltRight} from "react-icons/fa";


export default function MaterialIndex({className, ...props}) {
    const data = dummyData;
    const [answerTemplate] = useListApi(URLS.MaterialList);


    console.log(answerTemplate?.results)
    return (
        <div className={` ${className} pb-6`}>
            <HeroSection/>
            <div className={"flex mt-4 flex-col w-full justify-center items-center"}>

                <div className={"w-full gap-4 flex flex-col lg:w-4/5 py-4 lg:py-10 px-8 lg:px-16"}>
                    <div className={"flex flex-col gap-4"}>
                        <p className={"font-bold text-2xl mb-2"}>
                            Answer Templates <span className={"font-semibold  text-base"}>
                            (Available with VIP Elite Pass Purchase)
                        </span>
                        </p>
                        {
                            Object.keys(data).map((key, index) => {
                                return (
                                    <>
                                        {
                                            data[key].map((item, index) => {
                                                return <Row  {...item} key={index}/>
                                            })
                                        }

                                    </>
                                )
                            })

                        }
                        {
                            answerTemplate?.results.map((item, index) => {
                                if (item?.is_free)
                                    return <></>
                                return <AnswerTemplateRow
                                    link={item.file?.file ? getUri(item.file?.file) : null}
                                    {...item}

                                    key={index}/>
                            })
                        }
                        <AnswerTemplateRow
                            title={<div className={"text-end flex flex-row gap-2 justify-end items-center  text-blue-500"}>
                                <p>
                                    To purchase Items separately
                                </p>
                                <FaLongArrowAltRight/>


                            </div>}
                            buttonText={"Buy Now"}
                            link={" https://www.amazon.com/stores/Lance-Graney/author/B0D4PD6VBT?ref_=pe_2466670_811284380&isDramIntegrated=true&shoppingPortalEnabled=true"}
                        />
                    </div>

                    <div className={"flex flex-col gap-4"}>
                        <p className={"font-bold text-2xl mb-2"}>
                            Free Study Material <span className={"font-semibold  text-base"}>
                            (Accessible to all users)
                        </span>
                        </p>

                        {
                            answerTemplate?.results.map((item, index) => {
                                if (!item?.is_free)
                                    return <></>
                                return <AnswerTemplateRow
                                    link={item.file?.file ? getUri(item.file?.file) : null}
                                    {...item}

                                    key={index}/>
                            })
                        }

                    </div>
                </div>
            </div>
        </div>

    )
}